<script lang="ts" setup>
import type { CascaderInstance, CascaderNode, } from "element-plus"
import type { Props, } from "./types.ts"
import { ElCascader, } from "element-plus"
import "element-plus/es/components/cascader/style/index"

defineOptions({
  name: "ElCascader",
},)

const props = withDefaults(defineProps<Props>(), {
  validateEvent: true,
  teleported: true,
  persistent: true,
  showAllLevels: true,
},)

function defaultFilterMethod(node: CascaderNode, keyword: string,) {
  return node.text.toLowerCase().includes(keyword.toLowerCase(),)
}

const attrs: Record<string, unknown> = useAttrs()

const bindProps = computed(() => {
  const { filterMethod, ...rest } = props

  return {
    ...attrs,
    ...rest,
    filterMethod: filterMethod || defaultFilterMethod,
  }
},)

const cascaderRef = ref<CascaderInstance>()

defineExpose({
  cascaderRef,
},)
</script>

<template>
  <ElCascader
    ref="cascaderRef"
    v-bind="bindProps"
    class="w-full"
  />
</template>

<style lang="scss" scoped>
</style>
